import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authApi } from '../../api/auth';
import './Header.scss';

function Header({ isAuthenticated, onLogout }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    const { error } = await authApi.logout();
    if (!error) {
      onLogout();
      navigate('/');
    }
  };

  return (
    <header className="header">
      <div className="header__content">
        <Link to="/" className="header__title">Health Query</Link>
        <nav className="header__nav">
          {!isAuthenticated ? (
            <>
              <Link to="/login" className="header__link">Login</Link>
              <Link to="/register" className="header__link">Register</Link>
            </>
          ) : (
            <>
              <Link to="/dashboard" className="header__link">Dashboard</Link>
              <Link to="/profile" className="header__link">Profile</Link>
              <button onClick={handleLogout} className="header__link header__logout">
                Logout
              </button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}

export default Header; 